import React, { useEffect, useRef, useState, useCallback } from "react";

import PrescriptionForm from "./PrescriptionForm";
import "./prescription.scss";
import Container from "../../../../../../layouts/containers/Container";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/store";
import {
  setPresPrintaction,
  setPresPrintAmount,
  setPresPrintclinic,
  setPresPrintPatient,
  setPresPrintTreatment,
} from "../../../../../../redux/printstate/printActions";
import baseUrl from "../../../../../../api/baseUrl";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import PrePrint from "../../../../setting/preprint/PrePrint";
import { useParams } from "react-router-dom";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../../redux/loader/loaderActions";
import {
  addAditionalNote,
  addDiagnoseNote,
  addDiagnoses,
  addDiagnosesImage,
  addInvestigations,
  addPatientComplains,
  addPrescriptions,
  addTreatmentImage,
  removePrescription,
} from "../../../../../../redux/diagnosestate/diagnoseAction";
import { toast } from "react-toastify";
function Prescription() {
  const dispatch = useDispatch();
  const { ID } = useParams<{ ID: string }>();
  const prescription = useSelector(
    (state: RootState) => state.diagnose.prescription
  );
  const printRef = useRef<HTMLDivElement>(null);
  const [printData, setPrintData] = useState("");
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const getData = useCallback(() => {
    if (!ID) return;

    dispatch(setloadeActive());
    baseUrl
      .get("treatment/find-treatment", {
        headers: { treatmentid: ID },
      })
      .then((response) => {
        const {
          aditionalNote,
          patientComplain,
          diagnose,
          imageDiagnose,
          imageTreatment,
          complain,
          investigation,
          prescription,
        } = response.data.data;

        function cleanDoseArray(data: any) {
          return data.map((item: any) => ({
            _id: item?._id || "",
            dose: item?.doseId || "",
            drugsId: item?.drugsId?._id || "",
            drugs: item?.drugsId?.drugs || "",
            type: item?.drugsId?.type || "",
            duration: item?.duration || "",
            frequency: item?.frequency || "",
            createdAt: item?.createdAt || "",
          }));
        }

        dispatch(addAditionalNote(aditionalNote ?? ""));
        dispatch(addDiagnoseNote(patientComplain ?? ""));
        dispatch(addDiagnoses(diagnose ?? []));
        dispatch(addDiagnosesImage(imageDiagnose ?? []));
        dispatch(addTreatmentImage(imageTreatment ?? []));
        dispatch(addPatientComplains(complain ?? []));
        dispatch(addInvestigations(investigation ?? []));
        dispatch(addPrescriptions(cleanDoseArray(prescription) ?? []));
      })
      .catch(console.error)
      .finally(() => dispatch(setloadeDeactive()));
  }, [ID, dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);
  useEffect(() => {
    if (printData) {
      handleDownloadPdf();
    }
  }, [printData]);

  const dispatchPrintActions = useCallback(
    (e: any) => {
      e?.other?.clinicId?.prescriptionBill?.forEach((element: any) => {
        const { title, top, left, show, size } = element;
        if (top)
          dispatch(
            setPresPrintaction({ name: title, target: "top", value: top })
          );
        if (left)
          dispatch(
            setPresPrintaction({ name: title, target: "left", value: left })
          );
        if (show !== undefined)
          dispatch(
            setPresPrintaction({ name: title, target: "show", value: show })
          );
        if (size)
          dispatch(
            setPresPrintaction({ name: title, target: "size", value: size })
          );
      });
      dispatch(
        setPresPrintclinic({
          clinicName: e?.other?.clinicId?.title,
          tpNo: e?.other?.clinicId?.tpNo,
          address: e?.other?.clinicId?.address,
          drName: e?.other?.doctorId?.firstName,
          printImages: e?.other?.clinicId?.printImages,
        })
      );
      dispatch(
        setPresPrintPatient({
          invoiceNo: e?.other?.invoiceNo,
          regNo: e?.patientData?.regNo,
          fullName: e?.patientData?.fullName,
          mobileNo: e?.patientData?.mobileNo,
          gender: e?.patientData?.gender,
          dob: e?.patientData?.dob,
        })
      );

      function cleanDoseArray(data: any) {
        return data.map((item: any) => ({
          _id: item?._id || "",
          dose: item?.doseId || "",
          drugsId: item?.drugsId?._id || "",
          drugs: item?.drugsId?.drugs || "",
          type: item?.drugsId?.type || "",
          duration: item?.duration || "",
          frequency: item?.frequency || "",
          createdAt: item?.createdAt || "",
        }));
      }

      dispatch(setPresPrintTreatment(cleanDoseArray(e?.prescription)));
    },
    [dispatch]
  );
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    setSelectedIds((prev) => {
      if (checked) {
        return [...prev, name];
      } else {
        return prev.filter((id) => id !== name);
      }
    });
  };
  const handlePrint = useCallback(
    async (e: any) => {
      try {
        if (selectedIds.length === 0) {
          toast.error("select prescription.");
          return;
        }
        const response = await baseUrl.get(
          "/client/treatments/prescription/getPrescriptionById",
          {
            headers: { treatmentid: e, prescrip: selectedIds },
          }
        );
        setPrintData(response.data);
        dispatchPrintActions(response.data);
      } catch (error) {
        console.log(error);
      }
    },
    [selectedIds]
  );

  const remove = useCallback(
    async (e: any) => {
      try {
        const response = await baseUrl.patch(
          "/client/treatments/prescription/removePrescription",
          {},
          {
            headers: { treatmentid: ID, prescriptionid: e },
          }
        );
        console.log({ treatmentid: ID, prescriptionid: e });
        dispatch(removePrescription({ hasId: true, _id: e }));
      } catch (error) {
        console.log(error);
      }
    },
    [selectedIds]
  );

  const handleDownloadPdf = async () => {
    if (printRef.current) {
      printRef.current.style.display = "block";
      const element = printRef.current;
      const options = {
        scale: 2, // Improve quality
        useCORS: true, // Allow cross-origin images
        allowTaint: true,
      };

      const canvas = await html2canvas(element, options);
      const imgData = canvas.toDataURL("image/png");

      const imgWidth = 210; // A4 width in mm
      const imgProps = canvas.width / canvas.height;
      const imgHeight = imgWidth / imgProps; // Auto height based on aspect ratio

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [imgWidth, imgHeight], // Dynamic height
      });

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight, "", "FAST");

      // pdf.save(
      //   `${replaceWhitespacesWithUnderscores("clinicName")}_${invoiceNo}.pdf`
      // );
      // Open PDF in a new tab for printing
      const pdfBlob = pdf.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Create an iframe and append to document
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.width = "0";
      iframe.style.top = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      printRef.current.style.transform = "none";
      document.body.appendChild(iframe);
      iframe.src = blobUrl;

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          printRef.current!.style.display = "none";
        }, 500);
      };
    } else {
      console.error("Content ref is not defined");
    }
  };

  return (
    <Container className="prescription">
      <PrescriptionForm />
      <table>
        <thead>
          <tr>
            <th>select</th>
            <th>Drugs</th>
            <th>Dose</th>
            <th>Frequency</th>
            <th>Duratrion</th>
            <th>date</th>
            <th>action</th>
          </tr>
        </thead>
        <tbody>
          {prescription?.map((item: any, i: number) => (
            <tr key={i}>
              <td data-label="diagnose">
                <input
                  type="checkbox"
                  name={item._id}
                  checked={selectedIds.includes(item._id)}
                  onChange={handleCheckboxChange}
                />
              </td>
              <td data-label="diagnose">{item.drugs}</td>
              <td data-label="tooth No">{item.dose + item.type}</td>
              <td data-label="surface">{item.frequency}</td>
              <td data-label="note">{item.duration}</td>
              <td data-label="date">{item?.createdAt?.split("T")[0]}</td>
              <td data-label="action">
                <button onClick={() => remove(item?._id)}>Remove</button>
              </td>
            </tr>
          ))}
          <tr>
            <td></td>
          </tr>
        </tbody>
      </table>
      <button
        className="printButtons"
        onClick={() => {
          handlePrint(ID);
        }}
      >
        Print
      </button>

      <div className="prebill">
        <div ref={printRef} style={{ display: "none" }}>
          <PrePrint />
        </div>
      </div>
    </Container>
  );
}

export default Prescription;
